import { render, staticRenderFns } from "./dashVoucher.vue?vue&type=template&id=a8a9d7cc&scoped=true"
import script from "./dashVoucher.vue?vue&type=script&lang=js"
export * from "./dashVoucher.vue?vue&type=script&lang=js"
import style0 from "./dashVoucher.vue?vue&type=style&index=0&id=a8a9d7cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a9d7cc",
  null
  
)

export default component.exports